import Vue from 'vue'
import i18n from '@/i18n' // should be included, probably (unless you're not using i18n translations in any components that will be loaded here)
import MiniCart from '@/components/mini-cart/mini-cart'
import globalVue from '@/mixins/global'
import { registerGlobalBus, globalEvent } from '@/utils/globalBus'
// import '@/config/validation/vee-validate-config' // include if needed, for example if you have any input form that needs to be validated

require('@/assets/styles/main.scss')

// require('@/config/axios') // include if needed, probably is

registerGlobalBus(Vue)

Vue.prototype.$globalEvent = globalEvent()

Vue.config.productionTip = false
Vue.mixin(globalVue)
/**
 * If you copy this to another entry point, check if you're using proper element id in spark templates
 */
if (document.getElementById('mini-cart')) {
  Vue.component('mini-cart', MiniCart)

  new Vue({
    i18n,
    el: '#mini-cart'
  }).$mount('#mini-cart')
}
